import React, { useEffect, useState, useContext } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import baseURL from '../Common/Config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSearch, faTrash, faPen, faImage, faList } from '@fortawesome/free-solid-svg-icons';
import AddEventRecords from './AddEventRecords';
import FailureAlert from '../Common/Failure';
import { ThemeContext } from '../Common/ThemeProvider';
import { CallBackAlert } from '../Common/Validations/validation';
import DataTable from '../Common/DataTableList';
import moment from 'moment';
import ShowEventRegisterList from './ShowEventRegisterList';
import UploadEventImage from './UploadEventImage';

const EventRecords = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    const [displayAddEventRecords, setdisplayAddEventRecords] = useState("none");
    const [DisplayRegisterUsers, setDisplayRegisterUsers] = useState("none");
    const [DisplayImageUpload, setDisplayImageUpload] = useState("none");
    const [IsEdit, setIsEdit] = useState(0);
    const [EventSelectData, setEventSelectData] = useState({});
    const [EventImagePath, setEventImagePath] = useState(null);
    const [EventRecordEditData, setEventRecordEditData] = useState([]);
    const [EventRecordsData, setEventRecordsData] = useState([]);
    const [FilterEventRecords, setFilterEventRecords] = useState([]);

    useEffect(() => {
        FetchEventRecords();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const columns = [
        {
            name: 'Active',
            selector: row => { return <div style={{ marginLeft: "15px" }} className={row.IsDeleted ? "InActiveDiv" : "ActiveDiv"}></div> },
        },
        {
            name: "Event Image",
            width: "120px",
            selector: (row) => {
                return row.Image && (<div onClick={() => ShowImage(row)} style={{ borderRadius: "10px" }} className="m-1 cursor" title="Click to see Event Image..."><img width="45" height="45" alt="Logo" src={`${baseURL}EventImage/${row.Image}`}></img></div>)
            }
        },
        {
            name: 'Name',
            wrap: true,
            selector: row => row.Name,
            sortable: true,
        },
        {
            name: 'Heading',
            wrap: true,
            grow: 2,
            selector: row => row.Heading,
            sortable: true,
        },
        {
            name: 'Location',
            wrap: true,
            grow: 2,
            selector: row => row.Location,
            sortable: true,
        },
        {
            name: 'Start Date',
            wrap: true,
            selector: row => moment(row.StartDate).format("DD/MM/YYYY"),
            sortable: true,
        },
        {
            name: 'End Date',
            wrap: true,
            selector: row => moment(row.EndDate).format("DD/MM/YYYY"),
            sortable: true,
        },
        {
            name: 'Description',
            wrap: true,
            grow: 2,
            selector: row => row.Description,
            sortable: true,
        },
        {
            name: 'Created Date',
            width: "140px",
            wrap: true,
            selector: row => moment(row.createdAt).local().format("DD/MM/YYYY"),
            sortable: true,
        },
        {
            name: 'Action',
            width: "180px",
            selector: (row) => {
                return (
                    row.Name.toUpperCase() !== "ADMIN" && row.Name.toUpperCase() !== "USER" ? (<div>
                        <span className="cursorpointer" style={{ color: "#147a6f" }} title="View Registered Members" onClick={() => ShowregisterList(row)} ><FontAwesomeIcon style={{ marginRight: "10px" }} icon={faList} /></span>
                        <span className="cursorpointer" style={{ color: "#147a6f", marginLeft: "15px" }} title="Edit" onClick={() => EditSelectedEventRecord(row)} ><FontAwesomeIcon style={{ marginRight: "10px" }} icon={faPen} /></span>
                        <span className="cursorpointer" style={{ color: "green", marginLeft: "15px" }} title="Upload" onClick={() => OnImageUpload(row)} ><FontAwesomeIcon style={{ marginRight: "10px" }} icon={faImage} /></span>
                        <span className="cursorpointer" style={{ color: "#f61414", marginLeft: "15px" }} title="Delete" onClick={() => DeleteSelectedEventRecord(row._id)} ><FontAwesomeIcon style={{ marginRight: "10px" }} icon={faTrash} /></span>
                    </div>) : ("")
                )
            }
        }
    ];

    const ShowImage = (row) => {
        if (row.Image) {
            setEventImagePath(row.Image);
        }
        else {
            setEventImagePath(null);
        }
    }

    const ShowregisterList = (row) => {
        setEventSelectData(row);
        setDisplayRegisterUsers("block");
    }

    const OnImageUpload = (row) => {
        setEventSelectData(row);
        setDisplayImageUpload("block")
    }

    const onEventRecordsSearch = (searchValue) => {
        if (searchValue !== "") {
            let userSearchData = EventRecordsData.filter(c => c.Name.trim().toLowerCase().includes(searchValue.trim().toLowerCase()));
            setFilterEventRecords(userSearchData);
        }
        else {
            setFilterEventRecords(EventRecordsData);
        }
    };

    const FetchEventRecords = () => {
        Axiosfetch(baseURL + "GetEventDetails", "GET", null, EventRecordsuccess, Failure);
    };

    const EventRecordsuccess = (data) => {
        if (data && data.length > 0) {
            setEventRecordsData(data);
            setFilterEventRecords(data);
        }
        else {
            setEventRecordsData([]);
            setFilterEventRecords([]);
        }
    };

    const showEventRecords = () => {
        setdisplayAddEventRecords("block");
        setIsEdit(0);
    };

    const EditSelectedEventRecord = (EventRecordDetails) => {
        setEventRecordEditData(EventRecordDetails);
        setIsEdit(1);
        setdisplayAddEventRecords("block");
    };

    const hideEventRecord = () => {
        setdisplayAddEventRecords("none");
    };

    const DeleteSelectedEventRecord = (EventRecordID) => {
        Axiosfetch(baseURL + "DeleteEventRecord", "POST", { ID: EventRecordID }, EventRecordDeleteSuccess, Failure);
    };

    const EventRecordDeleteSuccess = (data) => {
        FetchEventRecords();

        CallBackAlert(data);
    };

    const HideRegisterMenu = () => {
        setDisplayRegisterUsers("none");
        setDisplayImageUpload("none");
        setEventSelectData({});
    }

    const Failure = (err) => {
        FailureAlert(err);
    };

    return (
        <div>
            <Header></Header>
            <div style={{ border: "none", boxShadow: "none" }} className="container-fluid InvoiceTheme sidemenu-show">
                <div className="row">
                    <div className="offset-md-2 col-md-4 col-sm-4">
                        <h5 className="align-right trackheader" style={{ fontWeight: "500" }}>Event Records</h5>
                    </div>
                    <div className="offset-md-2 col-md-3 col-sm-6 col-10" style={{ display: "flex" }}>
                        <input type="text" name="Name" placeholder="Search Event Records..."
                            className="form-control" style={{ marginRight: "10px", borderRadius: "20px", paddingLeft: "40px" }}
                            onChange={e => onEventRecordsSearch(e.target.value)}></input>
                        <div className={`${CurrentTheme}Color`} style={{ fontSize: "1rem", position: "absolute", left: "9%", top: "17%" }}>
                            <FontAwesomeIcon icon={faSearch} />
                        </div>
                    </div>
                    <div className="col-md-1 col-sm-2 col-2 align-left">
                        <span data-tip="Add Event" className={`cursor font-size-15rem addIconFocus ${CurrentTheme}Color`} onClick={showEventRecords}>
                            <FontAwesomeIcon icon={faPlus} />
                        </span>
                    </div>
                </div>
                <div className="row" style={{ padding: "15px" }}>
                    <div style={{ width: "100%", textAlign: "center", border: "1px solid #ccc", borderRadius: "10px" }}>
                        <DataTable
                            columns={columns}
                            data={FilterEventRecords}
                        />
                    </div>
                </div>
                {displayAddEventRecords === "block" && <AddEventRecords themeColor={CurrentTheme} hideeventRecord={hideEventRecord} getEventRecord={FetchEventRecords} edit={IsEdit} eventRecorddetail={EventRecordEditData} allEventRecord={EventRecordsData}></AddEventRecords>}
                {DisplayRegisterUsers === "block" && <ShowEventRegisterList EventDetails={EventSelectData} hideeventresgisterMenu={HideRegisterMenu}></ShowEventRegisterList>}
                {DisplayImageUpload === "block" && <UploadEventImage EventDetails={EventSelectData} HideUploadMenu={HideRegisterMenu} getEventRecord={FetchEventRecords}></UploadEventImage>}
                {EventImagePath && (
                    <div className="modal" style={{ display: "block" }}>
                        <div className="modal-content">
                            <div className={`modal-header header-style align-center`}>
                                <h6 className='pt-1' style={{ marginLeft: "5px" }}>Event Image</h6>
                                <span className="close" onClick={() => setEventImagePath(null)}>&times;</span>
                            </div>
                            <div className='align-center'>
                                <img width="345" height="345" alt="Logo" src={`${baseURL}EventImage/${EventImagePath}`}></img>
                            </div>
                        </div>
                    </div>)}
            </div>
        </div>
    );
};

export default EventRecords;